import type { PropsWithChildren } from 'react'
import React from 'react'

const OfferUrlContext = React.createContext<string | undefined>(undefined)

interface Props {
  url: string
}

export function OfferUrlProvider(props: PropsWithChildren<Props>) {
  const { url } = props

  return <OfferUrlContext.Provider value={url}>
    {props.children}
  </OfferUrlContext.Provider>
}

export default OfferUrlContext
